export default class keikkaAuthClass {
  constructor() {
    this.isLoaded = false;
    this.read = false; // read permission to order, this is the minimun for opening order
    this.originalEdit = false; // edit permission
    this.edit = false; // edit permission
    this.listPersons = false; // allow listing of order persons
    this.addPerson = false; // allow add/remove order persons
    this.editPerson = false; // allow change of main contact
    this.isPumppuAdmin = false; // may edit pumppuinfo after delivery
    this.isBetoniAdmin = false; // may edit betoniinfo after delivery
    this.isKeikkaAdmin = false; // may edit all info after delivery
    this.isPumppari = false;
  }
  setAuthDataFromJson(jsonData) {
    try {
      this.read = jsonData.readKeikka || false;
      this.originalEdit = jsonData.editKeikka || false;
      this.edit = jsonData.editKeikka || false;
      this.listPersons = jsonData.listKeikkaPersons || false;
      this.addPerson = jsonData.addKeikkaPerson || false;
      this.editPerson = jsonData.editKeikkaMainPerson || false;
      this.isPumppuAdmin = jsonData.isPumppuAdmin || false;
      this.isBetoniAdmin = jsonData.isBetoniAdmin || false;
      this.isKeikkaAdmin = jsonData.isKeikkaAdmin || false;
      this.isPumppari = jsonData.isPumppari || false;
      this.isLoaded = true;
    } catch (err) {
      console.log(err);
    }
  }
  get isAnyAdmin() {
    return this.isPumppuAdmin || this.isBetoniAdmin || this.isKeikkaAdmin;
  }
  get deletePerson() {
    return this.edit && this.listPersons && this.addPerson;
  }
  get authHash() {
    return (
      (this.read ? 2 : 1) +
      (this.edit ? 256 : 1) +
      (this.listPersons ? 4 : 1) +
      (this.addPerson ? 8 : 1) +
      (this.editPerson ? 16 : 1) +
      (this.isPumppuAdmin ? 32 : 1) +
      (this.isBetoniAdmin ? 64 : 1) +
      (this.isKeikkaAdmin ? 128 : 1)
    );
  }
}
